import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { motion } from "framer-motion";
import { getProfile } from "@/lib/profile";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Charge l'API Jitsi une seule fois
let jitsiLoader = null;
function loadJitsi() {
  if (window.JitsiMeetExternalAPI) return Promise.resolve();
  if (!jitsiLoader) {
    jitsiLoader = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://meet.jit.si/external_api.js";
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }
  return jitsiLoader;
}

export default function Visio() {
  const { room } = useParams();
  const [meta, setMeta] = useState(null);
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(false);
  const profile = getProfile();

  useEffect(() => {
    // room peut être un id de rendez-vous ou un nom de salle
    axios
      .get(`${API}/rdv/${room}/visio`)
      .then(({ data }) => setMeta(data))
      .catch(() => setMeta({ room, slot_label: null, name: null }));
  }, [room]);

  useEffect(() => {
    if (!meta) return;
    let api;
    let cancelled = false;
    loadJitsi()
      .then(() => {
        if (cancelled) return;
        api = new window.JitsiMeetExternalAPI("meet.jit.si", {
          roomName: meta.room,
          parentNode: document.getElementById("rav-jitsi"),
          width: "100%",
          height: "100%",
          userInfo: { displayName: profile?.prenom || meta.name || "Invitée" },
          configOverwrite: {
            prejoinConfig: { enabled: true },
            startWithAudioMuted: false,
            startWithVideoMuted: false,
          },
          interfaceConfigOverwrite: {
            MOBILE_APP_PROMO: false,
            TILE_VIEW_MAX_COLUMNS: 2,
          },
        });
        api.addListener("readyToClose", () => api.dispose());
        setReady(true);
      })
      .catch(() => setError(true));
    return () => {
      cancelled = true;
      if (api) api.dispose();
    };
  }, [meta]);

  return (
    <main className="rav-page rav-visio-page" data-testid="visio-page">
      <motion.img
        src="/logo-accueil.webp"
        alt="Respire Aime Vibre"
        className="rav-page-logo rav-visio-logo"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      />
      <h1 className="rav-page-title rav-visio-title" data-testid="visio-title">
        Votre rendez-vous visio{meta?.slot_label ? ` — ${meta.slot_label}` : ""}
      </h1>
      {error ? (
        <p className="rav-page-sub" data-testid="visio-error">
          La visio n'a pas pu se charger. Vérifiez votre connexion et rouvrez le lien.
        </p>
      ) : (
        <div className="rav-visio-frame" data-testid="visio-frame">
          {!ready && <p className="rav-page-sub">Préparation de votre salle…</p>}
          <div id="rav-jitsi" className="rav-visio-jitsi" />
        </div>
      )}
    </main>
  );
}
